module.exports = __webpack_public_path__ + "static/media/spinner.fdd452b7.svg";